import dictionary from 'config/dictionary';
import React from 'react';
import { interpolate } from 'utilities/interpolate';

/**
 * Provider refusals we can explain to a claimant, keyed on the exact user-safe
 * message voucher-prepaid-card returns. Shared by the claim form and the
 * claimed-card view so both show the same copy. A segment may supply its own
 * trust-level decline message, with `[error_code]` standing in for the code;
 * failing that, an operator that hides Huggg support gets its own sentence.
 */
const trustLevelMessage = (shortcode, declineMessage, operator) => {
  if (declineMessage) {
    return interpolate(declineMessage, '[error_code]', <>3065</>);
  }
  const code = `ERR-3065-${shortcode ?? 'no-shortcode'}`;
  if (operator.showHugggSupportLinks === false) {
    return `We were unable to create your account. ${operator.support} Quote error code ${code}.`;
  }
  return `We were unable to create your account. Please contact support@huggg.me, quoting this error code - ${code}`;
};

export const getKnownProviderErrors = (
  shortcode,
  declineMessage,
  operator = {},
) => ({
  'Forbidden - Invalid OTP': {
    declineCardRequest: false,
    displayMessage: dictionary.prepaidCards.errors.invalidOtp,
  },
  'Forbidden - ExceededProgramAnnualLimit': {
    declineCardRequest: true,
    displayMessage:
      'Your request for a card has been declined, as our system detects that the amount you have received in the last 12 months exceeds the program limit. Please contact the card sender for more information.',
  },
  'Forbidden - ExceededActiveAccountLimit': {
    declineCardRequest: true,
    displayMessage:
      'Your request for a card has been declined, as our system detects that you have already received the maximum number of cards allowed on this program. Please contact the card sender for more information.',
  },
  'Forbidden - TrustLevel': {
    declineCardRequest: true,
    displayMessage: trustLevelMessage(shortcode, declineMessage, operator),
  },
  // Both are the claimant's to fix, so the form stays in reach.
  'Forbidden - BelowMinimumAge': {
    declineCardRequest: false,
    displayMessage: dictionary.prepaidCards.errors.belowMinimumAge,
  },
  'Forbidden - InvalidFieldFormat': {
    declineCardRequest: false,
    displayMessage: dictionary.prepaidCards.errors.invalidFieldFormat,
  },
});

export default getKnownProviderErrors;
